    import React from "react";

    export const WhatsAppButton = (props) => {
    // Remove caracteres não numéricos do telefone
    //const cleanPhone = process.env.REACT_FONE;
    
    // Adiciona código do país se não tiver
    const whatsappNumber = process.env.REACT_FONE;
    
    // Mensagem padrão
    const message = encodeURIComponent(
        "Olá! Gostaria de mais informações sobre os serviços da Eletromaq."
    );
    
    const whatsappLink = `https://wa.me/554797552853?text=${message}`;

    return (
        <a
        href={whatsappLink}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        title="Fale conosco no WhatsApp"
        >
        <i className="fa fa-whatsapp"></i>
        </a>
    );
    };

